export default {
	createGrid(items, numCols, numRows) {
		var gridOccupancy = [];
		var maxRowUsed = 0;
		for(let y=0; y<numRows; y++) {
			let row = [];
			for(let x=0; x<numCols; x++) {
				row.push(false);
			}

			gridOccupancy.push(row);
		}

		function isOccupied(_x, _y, width, height) {
			
			for(let y=_y; y<_y+height; y++) {
				for(let x=_x; x<_x+width; x++) {
					if(gridOccupancy[y][x] != false) {
						return true;
					}
				}
			}
			return false;
		}

		function occupy(_x, _y, width, height) {
			for(let y=_y; y<_y+height; y++) {
				for(let x=_x; x<_x+width; x++) {
					gridOccupancy[y][x] = true;
				}
			}
		}

		// one optimization we could make is keeping track of which rows are full and starting there, instead of at the beginning.
		// Note this doesn't matter much for small grids but would get exponentially slower for large ones.
		function findFreeSpace(item) {

			// check for missing grid info.
			if(item.width == null || item.width == 0) {
				item.width = 1;
			}
			if(item.height == null || item.height == 0) {
				item.height = 1;
			}

			for(let y=0; y<numRows - (item.height-1); y++) {
				for(let x=0; x<numCols - (item.width-1); x++) {
					if(!isOccupied(x, y, item.width, item.height)) {
						occupy(x, y, item.width, item.height);
						item.gridColumnStart = x + 1;
						item.gridColumnEnd = x + item.width + 1;
						item.gridRowStart = y + 1;
						item.gridRowEnd = y + item.height + 1;

						if(item.gridRowEnd > maxRowUsed) {
							maxRowUsed = item.gridRowEnd;
						}

						return;
					}
				}
			}
		}



		// brute force fill
		items.forEach( findFreeSpace );

		return {
			items: items,
			maxRowUsed: maxRowUsed
		}
 	},
 	doIEGrid(container, options) {
 		let numCols = options.numCols;
 		let numRows = options.maxRows;

 		if(options.breakpoints) {
	 		options.breakpoints.forEach( breakpoint => {
	 			if(window.matchmedia(breakpoint.query).matches) {
	 				numCols = breakpoint.cols;
	 			}
	 		});
 		}

 		let items = Array.from(container.children);
 		items = items.map( item => { return { el: item, width: Number(item.dataset.gridWidth), height: Number(item.dataset.gridHeight) } });

		let res = this.createGrid(items, numCols, numRows);
		 
		var rowsTemplate = "-ms-grid-rows:";

		 for(var i=0; i<res.maxRowUsed-1; i++) {
			 rowsTemplate += options.gridRowTemplate + " ";
		 }

		container.setAttribute("style", rowsTemplate + ";");

 		// apply grid
 		items.forEach( (item) => {

			let appliedCol = item.gridColumnStart;
			let appliedRow = item.gridRowStart;

			if(options.useGutters) {
				appliedCol = (appliedCol-1) * 2 + 1;
				appliedRow = (appliedRow-1) * 2 + 1;
			}
 			var style = "-ms-grid-column: " + appliedCol + ";";
 
 			style += "-ms-grid-row: " + appliedRow + ";";

 			item.el.setAttribute("style", style);

 			// console.log(item);

 		// 	item.el.style["-ms-grid-column-start"] = item.gridColumnStart;
 		// 	item.el.style["-ms-grid-column-end"] = item.gridColumnEnd;

			// item.el.style["-ms-grid-row-start"] = item.gridRowStart;
 		// 	item.el.style["-ms-grid-row-end"] = item.gridRowEnd;
 		});

 	},
 	test() {
 		// console.log(this.createGrid([
 		// 	{ width: 1, height: 2 },
 		// 	{ width: 1, height: 1 },
 		// 	{ width: 1, height: 1 },
 		// 	{ width: 1, height: 2 },
 		// 	{ width: 2, height: 1 }
 		// ], 3, 5));
 	}
}